<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
</style>

<template>
  <div>
    <b-form validated @submit="onSubmit" @reset="onReset">
      <div class="d-flex justify-content-between">
        <h5></h5>
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              ><span v-if="form.intId === undefined">Save</span><span v-else>Update</span></b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <b-form-group
            id="input-group-startDateTime"
            label="Start Date Time:"
            label-for="input-startDateTime"
          >
            <b-form-input
              id="input-startDateTime"
              v-model="form.startDateTime"
              type="datetime-local"
              placeholder="Enter Start Date Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-endDateTime"
            label="End Date Time:"
            label-for="input-endDateTime"
          >
            <b-form-input
              id="input-endDateTime"
              v-model="form.endDateTime"
              type="datetime-local"
              placeholder="Enter End Date Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-coreNo"
            label="Core no:"
            label-for="input-coreNo"
          >
            <b-form-input
              id="input-coreNo"
              v-model="form.coreNo"
              type="number"
              step="0.001"
              placeholder="Enter Core no"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-coringType"
            label="Coring Type:"
            label-for="input-coringType"
          >
            <b-form-select
              id="input-coringType"
              v-model="form.coringType"
              type="text"
              placeholder="Enter Coring Type"
              :options="comboOptionCoringType"
              :disabled="!editable"
              @change="changeCoringType"
            ></b-form-select>
          </b-form-group>

          <div v-if="isSidewallCoring" ref="containerSidewallCoring">
            <h5 align="center">Sidewall Coring</h5>
            <hr />
            <b-form-group
              id="input-group-diameterSidewall"
              label="Diameter:"
              label-for="input-diameterSidewall"
            >
              <b-form-input
                id="input-diameterSidewall"
                v-model="form.diameterSidewall"
                type="number"
                step="0.001"
                placeholder="Enter Diameter Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-contractorSidewall"
              label="Contractor:"
              label-for="input-contractorSidewall"
            >
              <b-form-input
                id="input-contractorSidewall"
                v-model="form.contractorSidewall"
                type="text"
                placeholder="Enter Contractor Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-recoverySidewall"
              label="Recovery :"
              label-for="input-recoverySidewall"
            >
              <b-form-input
                id="input-recoverySidewall"
                v-model="form.recoverySidewall"
                type="number"
                step="0.001"
                placeholder="Enter Recovery  Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-analysisCompanySidewall"
              label="Analysis Company:"
              label-for="input-analysisCompanySidewall"
            >
              <b-form-input
                id="input-analysisCompanySidewall"
                v-model="form.analysisCompanySidewall"
                type="text"
                placeholder="Enter Analysis Company Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-formationSidewall"
              label="Formation:"
              label-for="input-formationSidewall"
            >
              <b-form-input
                id="input-formationSidewall"
                v-model="form.formationSidewall"
                type="text"
                placeholder="Enter Formation Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-noShotSidewall"
              label="No Shot:"
              label-for="input-noShotSidewall"
            >
              <b-form-input
                id="input-noShotSidewall"
                v-model="form.noShotSidewall"
                type="number"
                step="0.001"
                placeholder="Enter No Shot Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-noRecoveredSidewall"
              label="No Recovered:"
              label-for="input-noRecoveredSidewall"
            >
              <b-form-input
                id="input-noRecoveredSidewall"
                v-model="form.noRecoveredSidewall"
                type="number"
                step="0.001"
                placeholder="Enter No Recovered Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-noMisfiresSidewall"
              label="No Misfires:"
              label-for="input-noMisfiresSidewall"
            >
              <b-form-input
                id="input-noMisfiresSidewall"
                v-model="form.noMisfiresSidewall"
                type="text"
                placeholder="Enter No Misfires Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-preservationMethodSidewall"
              label="Preservation Method:"
              label-for="input-preservationMethodSidewall"
            >
              <b-form-input
                id="input-preservationMethodSidewall"
                v-model="form.preservationMethodSidewall"
                type="text"
                placeholder="Enter Preservation Method Sidewall"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <br />
            <b-form-group
              id="input-group-remarksSidewall"
              label="Remarks:"
              label-for="input-remarksSidewall"
              style="width: 100%"
            >
              <b-form-textarea
                id="input-remarksSidewall"
                v-model="form.remarksSidewall"
                type="text"
                placeholder="Enter Remarks Sidewall"
                :disabled="!editable"
                rows="5"
              ></b-form-textarea>
            </b-form-group>

            <hr />
            <CoringSidewallDesc
              :submit-id="submitId"
              :editable-ops="editable"
            />
          </div>

          <div v-if="!isSidewallCoring" ref="containerCoring">
            <h5 align="center">Coring</h5>
            <hr />
            <b-form-group
              id="input-group-diameter"
              label="Diameter:"
              label-for="input-diameter"
            >
              <b-form-input
                id="input-diameter"
                v-model="form.diameter"
                type="number"
                step="0.001"
                placeholder="Enter Diameter"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-intervalCut"
              label="Interval Cut:"
              label-for="input-intervalCut"
            >
              <b-form-input
                id="input-intervalCut"
                v-model="form.intervalCut"
                type="number"
                step="0.001"
                placeholder="Enter Interval Cut"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-coreBitType"
              label="Core Bit Type:"
              label-for="input-coreBitType"
            >
              <b-form-input
                id="input-coreBitType"
                v-model="form.coreBitType"
                type="text"
                placeholder="Enter Core Bit Type"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-coreBitDiameter"
              label="Core Bit Diameter:"
              label-for="input-coreBitDiameter"
            >
              <b-form-input
                id="input-coreBitDiameter"
                v-model="form.coreBitDiameter"
                type="number"
                step="0.001"
                placeholder="Enter Core Bit Diameter"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-contractor"
              label="Contractor:"
              label-for="input-contractor"
            >
              <b-form-input
                id="input-contractor"
                v-model="form.contractor"
                type="text"
                placeholder="Enter Contractor"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-recovery"
              label="Recovery :"
              label-for="input-recovery"
            >
              <b-form-input
                id="input-recovery"
                v-model="form.recovery"
                type="number"
                step="0.001"
                placeholder="Enter Recovery "
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-innerBarrelUsed"
              label="Inner Barrel Used:"
              label-for="input-innerBarrelUsed"
            >
              <b-form-input
                id="input-innerBarrelUsed"
                v-model="form.innerBarrelUsed"
                type="text"
                placeholder="Enter Inner Barrel Used"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-barrelType"
              label="Barrel Type:"
              label-for="input-barrelType"
            >
              <b-form-input
                id="input-barrelType"
                v-model="form.barrelType"
                type="text"
                placeholder="Enter Barrel Type"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-barrelLength"
              label="Barrel Length:"
              label-for="input-barrelLength"
            >
              <b-form-input
                id="input-barrelLength"
                v-model="form.barrelLength"
                type="number"
                step="0.001"
                placeholder="Enter Barrel Length"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-preservationMethod"
              label="Preservation Method:"
              label-for="input-preservationMethod"
            >
              <b-form-input
                id="input-preservationMethod"
                v-model="form.preservationMethod"
                type="text"
                placeholder="Enter Preservation Method"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-catchMethod"
              label="Catch Method:"
              label-for="input-catchMethod"
            >
              <b-form-input
                id="input-catchMethod"
                v-model="form.catchMethod"
                type="text"
                placeholder="Enter Catch Method"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-analysisCompany"
              label="Analysis Company:"
              label-for="input-analysisCompany"
            >
              <b-form-input
                id="input-analysisCompany"
                v-model="form.analysisCompany"
                type="text"
                placeholder="Enter Analysis Company"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-inclination"
              label="Inclination:"
              label-for="input-inclination"
            >
              <b-form-input
                id="input-inclination"
                v-model="form.inclination"
                type="number"
                step="0.001"
                placeholder="Enter Inclination"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-formation"
              label="Formation:"
              label-for="input-formation"
            >
              <b-form-input
                id="input-formation"
                v-model="form.formation"
                type="text"
                placeholder="Enter Formation"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-cutLost"
              label="Cut Lost:"
              label-for="input-cutLost"
            >
              <b-form-input
                id="input-cutLost"
                v-model="form.cutLost"
                type="number"
                step="0.001"
                placeholder="Enter Cut Lost"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-ecd"
              label="ECD:"
              label-for="input-ecd"
            >
              <b-form-input
                id="input-ecd"
                v-model="form.ecd"
                type="number"
                step="0.001"
                placeholder="Enter ECD"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-remarks"
              label="Remarks:"
              label-for="input-remarks"
            >
              <b-form-textarea
                id="input-remarks"
                v-model="form.remarks"
                type="text"
                placeholder="Enter Remarks"
                :disabled="!editable"
                rows="5"
              ></b-form-textarea>
            </b-form-group>
            <hr />
            <CoringDesc :submit-id="submitId" :editable-ops="editable" />
          </div>
        </div>
        <hr />
      </div>

      <!-- <p>{{ selectedRow }}</p> -->
    </div>
  </div>

  <!-- MODALS -->
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import CoringDesc from '@components/form/drilling-activity/coring-desc'
import CoringSidewallDesc from '@components/form/drilling-activity/coring-sidewell-desc'
import notify from "devextreme/ui/notify"
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFormGenerator)

export default {
  components: { CoringDesc, CoringSidewallDesc },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      isSidewallCoring: true,
      editableOps: this.editable,
      comboOptionCoringType: [
        { value: 'SIDEWALL_CORING', text: 'SIDEWALL CORING' },
        { value: 'CORING', text: 'CORING' },
      ],
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
    form: function (val) {
      if (val.coringType === 'SIDEWALL_CORING') this.isSidewallCoring = true
      else this.isSidewallCoring = false
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.form.coringType = 'SIDEWALL_CORING'
      this.loadAllCombo()
      this.form = []
      this.getActivityCoring({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {},
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityCoring({ params: data }).then((resp) => {
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityCoring({ params: data }).then((resp) => {
          this.hasData = true
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    changeCoringType(val) {
      console.log('changeCoringType', val)
      if (val === 'SIDEWALL_CORING') this.isSidewallCoring = true
      else this.isSidewallCoring = false
      console.log('isSidewallCoring', this.isSidewallCoring)
    },
  },
}
</script>